
import React from "react";
import { OccupationAutocomplete } from "@/components/shared/OccupationAutocomplete";

interface ImprovedOccupationAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  userRole?: string;
}

export const ImprovedOccupationAutocomplete: React.FC<ImprovedOccupationAutocompleteProps> = ({
  value,
  onChange,
  error,
  userRole = "sponsor"
}) => {
  return (
    <OccupationAutocomplete
      value={value}
      onChange={onChange}
      error={error}
      label="Área de atuação"
      userRole={userRole}
    />
  );
};
